export var HOME_INSPECTION_CTA_NAME = 'valuation_tap_book_home_appointment';
export var CALLBACK_CTA_NAME = 'valuation_tap_assisted_inspection';
export var HOW_TO_SELL_CAR_WIDGET_CTA_NAME = 'quote-now-cta';
export var HOW_TO_SELL_CAR_WIDGET_NUMBER_PLATE_LINK_NAME = 'numberPlateO2OStartLink';
export var FAQ_WIDGET_DESKTOP = 'faq-desktop';
export var FAQ_WIDGET_MOBILE = 'faq-mobile';
export var HOW_TO_SELL_CAR_DESKTOP = 'desktop-how-to-sell-car-widget';
export var HOW_TO_SELL_CAR_MOBILE = 'mobile-how-to-sell-car-widget';
export var EQUAL_WIDTH_COLUMN_STATIC_CONTENT = 'EqualWidthColumnStaticContent';
export var ScrollAbleList = 'ScrollAbleList';
export var CALLBACK_ASSISTED_SI_HOME = 'callback_assisted_si_home';
export var VALUATION_EVALUATE_ANOTHER_CAR = 'valuation_tap_evaluate_another_car';
export var UPAGO_CAR_CTA = 'upago-car-cta';
export var CALLBACK_ASSISTED_SI_REDIRECTION_CTA = 'callback_assisted_si_redirection_cta';
export var ASSISTED_INSPECTION_TAP_CONTINUE = 'assisted_inspection_tap_continue';
export var ASSISTED_INSPECTION_SUCCESSFUL = 'assisted_inspection_successful';
export var SELF_INSPECT = 'Self Inspect';
export var SELL_YOUR_CAR_CTA_NAME = 'sell-your-car-cta';
export var SELL_HOME_TAP_CONTINUE = 'sell_home_tap_continue';